import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type SubmitRmaDraftResponse = { id: string, state: string, sent_datetime: string }

export class SubmitRmaDraft extends RmaRequest<SubmitRmaDraftResponse, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit = { method: 'PUT' }

  constructor({ rmaId }: { rmaId: string }) {
    super()
    this.path = `account/rma/draft/submit/${rmaId}/`
  }

  override parseResponse = (data: unknown) => data as SubmitRmaDraftResponse
}
